// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Syne', 'Syne Fallback'","fontStyle":"normal"},"className":"__className_744198","variable":"__variable_744198"};